import { Component, OnInit, ViewChildren, QueryList, OnDestroy, Input, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { CheckoutService } from '../checkout.service';
import { CheckoutItemModel } from '../models/item.model';
import { NgForm, FormGroup, NgModelGroup } from '@angular/forms';
import { UIRouter } from '@uirouter/core';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CheckoutBasketModel } from '../models/basket.model';
import { InputTextComponent } from '../../form/input/text/text.component';
import { InputTextareaComponent } from '../../form/input/textarea/textarea.component';

@Component({
  templateUrl: './index.component.html',
  styleUrls: [
    './index.component.scss'
  ]
})
export class CheckoutIndexComponent implements OnInit, OnDestroy {
  private itemsSub: Subscription;

  public designValues;
  public spiritualValues;

  public basket: CheckoutBasketModel;

  public items: CheckoutItemModel[];

  public voucherAlreadyAdded: boolean = false;
  public onlyVoucherButtonsInBasket: boolean = false;
  public videoButtonsHtml: SafeHtml;
  private videoRoot: string = 'https://d3l6ptb89vyf3h.cloudfront.net/videos';
  public showMultipleButtonsVideo: boolean = false;
  public maxSignsNumber: number = 320;
  private availableSigns: Array<Object> = [
    {
      available: this.maxSignsNumber
    }
  ];

  public voucher = {
    code: null,
    isValid: null
  };

  @Input()
  public stateParams: { code: string };

  @ViewChildren('group')
  public groups: QueryList<NgModelGroup>;

  constructor(
    private router: UIRouter,
    private checkoutService: CheckoutService,
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef,
    private domSanitizer: DomSanitizer
  ) {
  }

  public ngOnInit() {
    this.designValues = this.checkoutService.designValues;
    this.spiritualValues = this.checkoutService.spiritualValues;

    this.items = this.checkoutService.items;
    
    if (this.items.length > 1) {
      for (let itmCnt = 1; itmCnt < this.items.length; itmCnt++) {
        this.availableSigns.push({ available: this.maxSignsNumber });
      }
    }
    
    this.videoButtonsHtml = this.domSanitizer.bypassSecurityTrustHtml(`<video playsinline muted="muted" id="video3" class="Video" poster="/assets/img/multiple_buttons_video_fallback5.png" autoplay="autoplay" loop="loop">
        <source src="${this.videoRoot}/no_audio_1_bg_holeknopf_large.mp4" type="video/mp4" />
        <source src="${this.videoRoot}/no_audio_1_bg_holeknopf_large.webm" type="video/webm" />
      </video>`);    
    
    this.checkOnlyVoucherButtonsInBasket();

    this.itemsSub = this.checkoutService.itemsChange.subscribe(
      (items) => {
        this.items = items;
        this.checkOnlyVoucherButtonsInBasket();
      }
    );

    if (this.stateParams && this.stateParams.code) {
      this.voucher.code = this.stateParams.code;

      this.verifyCode(true);
    } else {
      if (!this.checkoutService.items || !this.checkoutService.items.length) {
        this.checkoutService.addItem(new CheckoutItemModel());
      }
    }
  }

  public ngOnDestroy() {
    this.itemsSub.unsubscribe();
  }
  
  public ngAfterViewChecked() {
    setTimeout(() => {
      let greetingsMessageTextareas = document.querySelectorAll('[id*="greetingsMessage-"]');
      
      if (typeof greetingsMessageTextareas !== 'undefined') {
        if (greetingsMessageTextareas !== null) {
          for (let areaCnt = 0; areaCnt < greetingsMessageTextareas.length; areaCnt++) {
            this.availableSigns[areaCnt]['available'] = this.maxSignsNumber - parseInt(greetingsMessageTextareas[areaCnt]['value'].length);
          }
        }
      }
    }, 0);
  }
  
  private checkOnlyVoucherButtonsInBasket() {
    let voucherCounter = 0;
    let basket = this.checkoutService.items;
    
    basket.forEach((buttonItem) => {
      if (buttonItem.voucher) {
        voucherCounter++;
      }
    });
    
    if (voucherCounter === basket.length) {
      this.onlyVoucherButtonsInBasket = true;
    } else {
      this.onlyVoucherButtonsInBasket = false;
    }
  }

  public handleAddItem() {
    this.availableSigns.push({ available: this.maxSignsNumber });
    this.checkoutService.addItem(new CheckoutItemModel());
    this.changeDetectorRef.detectChanges();
  }

  public handleItemChange(item: CheckoutItemModel, index: number) {
    this.checkoutService.updateItem(item, index);
  }

  public handleItemRemove(item: CheckoutItemModel, index: number) {    
    this.availableSigns.splice(index, 1);
    this.checkoutService.removeItem(item, index);
    
    if (this.items.length < 1) {
      this.availableSigns.push({ available: this.maxSignsNumber });
      this.checkoutService.addItem(new CheckoutItemModel());
    }
    
    this.changeDetectorRef.detectChanges();
  }

  public handleSubmit(form: NgForm) {
    this.groups.forEach((group) => {
      if (group.control) {
        group.control.markAsTouched();
      }
    });

    if (this.voucher.code !== null && this.voucher.code !== '' && !this.voucherAlreadyAdded) {
      this.verifyCode();
      return;
    }

    if (form.valid) {
      this.checkoutService.items = this.items;

      this.router.stateService.go('main.checkout.register');
    } else {
      let firstInvalidControl = this.elementRef.nativeElement.querySelectorAll('.ng-invalid');
      
      if (firstInvalidControl.length > 0) {
        if (typeof firstInvalidControl[1] !== 'undefined' && firstInvalidControl[1] !== null) {
          firstInvalidControl[1].scrollIntoView(true);
        } else {
          firstInvalidControl[0].scrollIntoView(true);
        }
      }
    }
  }

  public handleVoucherCodeChange() {
    this.voucher.isValid = null;
    this.voucherAlreadyAdded = false;
  }

  public hasError(field: any, form: NgForm, type: string = 'required') {
    return field.invalid &&
      form.submitted &&
      field.errors &&
      field.errors[type];
  }

  public verifyCode(isInitial: boolean = false) {
    if (this.voucher.code) {
      this.voucher.isValid = null;
      this.voucherAlreadyAdded = false;

      let voucherFound = false;

      if (this.items) {
        for (const item of this.items) {
          if (this.voucher.code && item.voucher && item.voucher.code === this.voucher.code) {
            voucherFound = true;
          }
        }
      }

      if (!voucherFound) {
        this.checkoutService.voucherCheck(this.voucher.code)
          .subscribe((result) => {
            this.voucher.isValid = result.isValid;

            if (result.isValid) {
              const item = new CheckoutItemModel();
              item.voucher = result;

              if (result.isGift) {
                item.design = result.button.design;
                item.spiritual = result.button.spiritual;
                item.price = parseFloat(result.button.value);
              } else {
                item.design = 'weissgold';
              }

              if (this.checkoutService.items.length === 1 && !this.checkoutService.items[0].isTouched()) {
                this.checkoutService.removeItem(null, 0);
              }

              this.checkoutService.addItem(item);

              this.voucher.code = '';

              setTimeout(() => {
                this.voucher.isValid = null;
              }, 3000);
            } else if (isInitial) {
              if (!this.checkoutService.items || !this.checkoutService.items.length) {
                this.checkoutService.addItem(new CheckoutItemModel());
              }
              
              
              this.checkOnlyVoucherButtonsInBasket();
            }
          });
      } else {
        this.voucherAlreadyAdded = true;
      }
    }
  }
  
  public showRemoveButton(item: CheckoutItemModel, index: number) {
    return this.items.length > 1 || index === 0 && item.voucher;
  }
  
  public updateSignsNumber(item: CheckoutItemModel, index: number) {
    this.handleItemChange(item, index);
    this.availableSigns[index]['available'] = this.maxSignsNumber - parseInt(document.getElementById(`greetingsMessage-${index}`)['value'].length);
  }
  
  public getAvailableSigns(index: number) {
    return `${this.availableSigns[index]['available']} / ${this.maxSignsNumber}`;
  }
  
  public trackByIndex(index: number): number {
    if (typeof this.items !== 'undefined') {
      if (this.items.length < 1) {
        return 0;
      }  
    }
    
    return index;
  }
}


// WEBPACK FOOTER //
// ./src/app/checkout/index/index.component.ts